"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLocale = void 0;
const const_1 = require("../../const");
const setLocale = (client) => (locale) => {
    client.defaults.headers.common[const_1.LOCALE_HEADER] = locale;
};
exports.setLocale = setLocale;
